﻿import './../css/pyc.less';
import './pages/LocalMarket';
import { TweenLite, CSSPlugin } from "gsap/all";
import LocalMarket from './pages/LocalMarket';
import ClassListing from './pages/ClassListing';
import PartnersListing from './pages/Partners';
import Launch from './pages/Launch';
import Admin from './pages/Admin';
import RegistrationModal from './components/SignupModal';
import WaitlistModalClass from './components/WaitlistModal';

const plugins = [CSSPlugin];

window.d = document;
window.TweenLite = TweenLite;



const onLoadContent = () => {
    const body = d.querySelector("body");

    const localMarketPage = new LocalMarket();
    const ClassListingPage = new ClassListing();
    const _Launch = new Launch();
    const _partnersListing = new PartnersListing();
    const _admin = new Admin();

    window.waitlistModalClass = new WaitlistModalClass();
    window.registrationModal = new RegistrationModal();

}

if (document.readyState !== "loading") {
    onLoadContent();
}

document.addEventListener("DOMContentLoaded", () => {
    onLoadContent();
});